// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner_container__VEgjh","spinner":"LoadingSpinner_spinner__UnICz","spin":"LoadingSpinner_spin__UPoAk"};